import * as React from 'react';

import { BargainTermsInfo } from './BargainTermsInfo';
import { CommercialInfo } from './CommercialInfo';
import { CommercialMultiAdsFactoids } from './CommercialMultiAdsFactoids';
import * as styles from './FavoriteInfo.css';
import { FlatInfo } from './FlatInfo';
import { JKInfo } from './JKInfo';
import { SuburbanInfo } from './SuburbanInfo';
import { MainTitleContainer } from '../../containers/MainTitle';
import { IFavoriteEntity } from '../../types/results';
import { getIsOfferWithMultiAds } from '../../utils/getIsOfferWithMultiAds';
import { CardShields } from '../CardShields';

export interface IFavoriteInfoProps {
  favoriteEntity: IFavoriteEntity;
  isBooked: boolean;
}

export function FavoriteInfo({ favoriteEntity, isBooked }: IFavoriteInfoProps) {
  const {
    fullUrl,
    title,
    flatInfo,
    suburbanInfo,
    jkInfo,
    commercialInfo,
    commercialOwnership,
    bargainTerms,
    entityId,
    isCianPartner,
    externalOfferUrl,
    agentInfo,
    isEarlyAccessEnabled,
  } = favoriteEntity;
  const href = isCianPartner ? (externalOfferUrl as string) : fullUrl;

  const isCommercialMultiAds = getIsOfferWithMultiAds(commercialInfo);

  if (commercialInfo) {
    return (
      <div className={styles['base_info']}>
        <MainTitleContainer entityId={entityId} title={title} fullUrl={href} />
        <div data-testid="card-shields" className={styles['shields_wrapper']}>
          <CardShields
            agentLists={agentInfo?.agentLists}
            isCommericalOwner={!!commercialOwnership?.isFromOwner}
            isEarlyAccessEnabled={isEarlyAccessEnabled}
          />
        </div>
        {isCommercialMultiAds ? (
          <CommercialMultiAdsFactoids factoids={commercialInfo.factoids} />
        ) : (
          <CommercialInfo commercialInfo={commercialInfo} />
        )}
      </div>
    );
  }

  return (
    <>
      <div className={styles['base_info']}>
        <MainTitleContainer entityId={entityId} title={title} fullUrl={href} />
        {flatInfo && <FlatInfo flatInfo={flatInfo} />}
        {jkInfo && <JKInfo jkInfo={jkInfo} />}
        {suburbanInfo && <SuburbanInfo suburbanInfo={suburbanInfo} />}
        <div data-testid="card-shields" className={styles['shields_wrapper']}>
          <CardShields
            agentLists={agentInfo?.agentLists}
            isCommericalOwner={!!commercialOwnership?.isFromOwner}
            isEarlyAccessEnabled={isEarlyAccessEnabled}
          />
        </div>
      </div>
      <div className={styles['price_info']} data-name="price_info">
        {bargainTerms && (
          <BargainTermsInfo bargainTerms={bargainTerms} isNewbuilding={Boolean(jkInfo)} isBooked={isBooked} />
        )}
      </div>
    </>
  );
}
